import React, { useState } from 'react';
import Draggable from "react-draggable";
import folderGreen from '../assets/FolderGreen.png';
import folderBlue from '../assets/FolderCode.png';
import folderOrange from '../assets/FolderOrange.png';
import folderYellow from '../assets/FolderYellow.png';
import folderLime from '../assets/FolderLime.png';
import bluefolder from '../assets/FolderBlue.png'
import FolderPictures from '../assets/FolderPictures.png';
import Modal from '../components/Modal';
import AboutMe from '../data/constant';
import Projects from '../components/Projects';
import Experience from '../components/Experience';
import Skills from '../components/Skills';
import Profiles from '../components/Profiles';
import Photos from '../components/Photos';
import Contact from './Contact';


const Home = () => {
  const [modals, setModals] = useState([]);

  const handleDoubleClick = (title, data) => {
    const newModal = {
      id: new Date().getTime(),
      title: title,
      data: data,
    };
    setModals([...modals, newModal]);
  };

  const closeModal = (id) => {
    setModals(modals.filter(modal => modal.id !== id));
  };

  return (
    <div className='relative flex flex-row left-4 gap-8 flex-wrap'><div className='relative flex flex-col left-4 gap-4 flex-wrap'>
      <Draggable>
        <div className='flex flex-col w-fit text-center p-[6px] rounded hover:bg-[#fff4]' onDoubleClick={() => handleDoubleClick('About Me', <AboutMe />)}>
          <img src={folderGreen} alt="Green Folder" className='protect-image w-16' />
          <p className='text-white'>About Me</p>
        </div>
      </Draggable>

      <Draggable>
        <div className='flex flex-col w-fit text-center p-[6px] rounded hover:bg-[#fff4]' onDoubleClick={() => handleDoubleClick('Projects', <Projects />)}>
          <img src={folderBlue} alt="Blue Folder" className='protect-image w-16' />
          <p className='text-white'>Projects</p>
        </div>
      </Draggable>

      <Draggable>
        <div className='flex flex-col w-fit text-center p-[6px] rounded hover:bg-[#fff4]' onDoubleClick={() => handleDoubleClick('Experience', <Experience />)}>
          <img src={folderOrange} alt="Orange Folder" className='protect-image w-16' />
          <p className='text-white'>Experience</p>
        </div>
      </Draggable>

        <Draggable>
          <div className='flex flex-col w-fit text-center p-[6px] rounded hover:bg-[#fff4]' onDoubleClick={() => handleDoubleClick('Skills', <Skills />)}>
            <img src={folderYellow} alt="Yellow Folder" className='protect-image w-16' />
            <p className='text-white'>Skills</p>
          </div>
        </Draggable>
      
    </div>
    <div className='relative flex flex-col left-4 gap-4 flex-wrap'>
        <Draggable>
          <div className='flex flex-col w-fit text-center p-[6px] rounded hover:bg-[#fff4]' onDoubleClick={() => handleDoubleClick('Profiles', <Profiles />)}>
            <img src={folderLime} alt="Lime Folder" className='protect-image w-16' />
            <p className='text-white'>Profiles</p>
          </div>
        </Draggable>

        <Draggable>
          <div className='flex flex-col w-fit text-center p-[6px] rounded hover:bg-[#fff4]' onDoubleClick={() => handleDoubleClick('Photos', <Photos />)}>
            <img src={FolderPictures} alt="Pictures Folder" className='protect-image w-16' />
            <p className='text-white'>Photos</p>
          </div>
        </Draggable>

        <Draggable>
        <div className='flex flex-col w-fit text-center p-[6px] rounded hover:bg-[#fff4]' onDoubleClick={() => handleDoubleClick('Contact', <Contact />)}>
          <img src={bluefolder} alt="Pictures Folder" className='protect-image w-16' />
          <p className='text-white'>Contact</p>
        </div>
        </Draggable>

        
      </div>
      <div className='absolute flex flex-col left-4 gap-4 flex-wrap right-0'>
        <div className="absolute right-10 top-32 p-4 rounded-lg shadow-lg text-white text-center border">
          <p className="font-bold text-3xl font-mono mb-6">Smit Khobragade</p>
          <p className="text-xl mb-6 font-mono">Full-Stack Developer</p>
          <p className="text-lg mb-6 font-mono">Linkedin <b> 5k+</b> Followers</p>
          <p className="text-lg mb-6 font-bold font-mono">Top Computer Science Voice</p>
        </div>
      </div>
      {modals.map(modal => (
        <Modal
          key={modal.id}
          id={modal.id}
          title={modal.title}
          data={modal.data}
          onClose={closeModal} />
      ))}
      </div>
  );
};

export default Home;
